import React, { ComponentProps, FunctionComponent } from "react";

const ECommerceIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 34 34",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M0 2.09648C0 1.46081 0.517447 0.943359 1.15312 0.943359H31.904C32.5397 0.943359 33.0571 1.46081 33.0571 2.09648V26.6969C33.0571 27.334 32.5397 27.85 31.904 27.85H1.15312C0.517447 27.85 0 27.334 0 26.6969V9.78494C0 9.14783 0.517447 8.63182 1.15312 8.63182C1.79023 8.63182 2.30624 9.14783 2.30624 9.78494V25.5438H30.7509V3.2496H2.30624V3.63447C2.30624 4.27158 1.79023 4.78759 1.15312 4.78759C0.517447 4.78759 0 4.27158 0 3.63447V2.09648Z",
      fill: "currentColor",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M12.3011 26.6961C12.3011 26.059 12.8172 25.543 13.4543 25.543H19.6033C20.2404 25.543 20.7564 26.059 20.7564 26.6961V32.8466C20.7564 33.4822 20.2404 33.9997 19.6033 33.9997H13.4543C12.8172 33.9997 12.3011 33.4822 12.3011 32.8466V26.6961ZM14.6074 27.8492V31.6934H18.4501V27.8492H14.6074Z",
      fill: "currentColor",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M6.15033 32.8475C6.15033 32.2103 6.66634 31.6943 7.30345 31.6943H25.7534C26.3905 31.6943 26.9065 32.2103 26.9065 32.8475C26.9065 33.4831 26.3905 34.0006 25.7534 34.0006H7.30345C6.66634 34.0006 6.15033 33.4831 6.15033 32.8475Z",
      fill: "currentColor",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M9.23484 10.4108C9.30691 9.83282 9.79698 9.40039 10.3779 9.40039H22.6788C23.2597 9.40039 23.7498 9.83282 23.8219 10.4108L25.3599 22.7103C25.4017 23.0389 25.2993 23.369 25.0802 23.6169C24.8611 23.8648 24.5469 24.0061 24.2154 24.0061H8.84141C8.50989 24.0061 8.19566 23.8648 7.97655 23.6169C7.75744 23.369 7.65512 23.0389 7.69692 22.7103L9.23484 10.4108ZM11.397 11.7066L10.1473 21.6999H22.9095L21.6598 11.7066H11.397Z",
      fill: "currentColor",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M16.5287 7.09335C15.23 7.09335 13.8376 8.43673 13.8376 10.5527C13.8376 11.1898 13.3216 11.7058 12.6845 11.7058C12.0488 11.7058 11.5314 11.1898 11.5314 10.5527C11.5314 7.57478 13.581 4.78711 16.5287 4.78711C19.4764 4.78711 21.5261 7.57478 21.5261 10.5527C21.5261 11.1898 21.0086 11.7058 20.373 11.7058C19.7358 11.7058 19.2198 11.1898 19.2198 10.5527C19.2198 8.43673 17.8275 7.09335 16.5287 7.09335Z",
      fill: "currentColor",
    })
  );
};

const ForwardRef = React.forwardRef(ECommerceIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
